/**
 * Decomposes a token string into a well formed json object
 * @param token token from el patron
 */
export const decomposeJWT = (token: string) => {
  if (!token) {
    return;
  }

  let parsedJson;
  try {
    const base = token.split('.')[1];
    const base64 = base && base.replace(/-/g, '+').replace(/_/g, '/');
    if (base64) {
      parsedJson = JSON.parse(window.atob(base64));
    }
  } catch (e) {}

  return parsedJson;
};
